/**
*
* Toggle
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import Label from 'components/Label';

import {
  ToggleWrapper,
  ToggleContainer,
  ToggleSlider
} from './styles/ToggleStyles';


class Toggle extends React.PureComponent {
  constructor() {
    super();

    this.handleToggle = this.handleToggle.bind(this);

    this.state = {
      active: false,
      label: ''
    };
  }

  componentDidMount() {
    this.setState({
      label: this.props.label
    });
  }

  handleToggle() {


    this.setState((prevState) => {
      return {
        active: !prevState.active,
      }
    })
    this.props.handleToggle()
  }
  
  render() {

    const { 
      label,
      active
    } = this.state;

    return (
      <ToggleWrapper>
        <ToggleContainer
          onClick={this.handleToggle}
          isActive={active}
        >
          <ToggleSlider isActive={active} />
        </ToggleContainer>
        <Label 
          title={label} 
          thisStyles={{
            width: 'unset',
            margin: 0
          }}
        />
      </ToggleWrapper>
    )
  }
};

Toggle.propTypes = {
  titleOff: PropTypes.string,
  titleOn: PropTypes.string,
  handleToggle: PropTypes.func
};

export default Toggle;
